import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../student/Navbar';
import ITSidebar from './ITSidebar';
import { motion } from 'framer-motion';
import * as XLSX from 'xlsx';
import {
  FaPlus,
  FaTrash,
  FaUpload,
  FaDownload,
  FaCheck,
  FaTimes,
  FaUserPlus,
  FaFileExcel,
  FaFileCsv,
  FaExclamationTriangle,
  FaInfoCircle,
  FaCheckCircle,
  FaExclamationCircle,
  FaQuestionCircle,
  FaCog as FaSettings,
  FaChartBar,
  FaTable,
  FaList,
  FaTh,
  FaThList,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaExpand,
  FaCompress,
  FaCopy,
  FaClipboard,
  FaPrint,
  FaShare,
  FaExternalLinkAlt,
  FaArrowLeft,
  FaArrowRight,
  FaArrowUp,
  FaArrowDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaChevronDown,
  FaMinus,
  FaEquals,
  FaPercentage,
  FaCalculator,
  FaClock,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarTimes,
  FaHistory,
  FaUndo,
  FaRedo,
  FaSave,
  FaTimesCircle,
  FaCheckSquare,
  FaSquare,
  FaCircle,
  FaDotCircle,
  FaStop,
  FaPlay,
  FaPause,
  FaStopCircle,
  FaPlayCircle,
  FaPauseCircle,
  FaForward,
  FaBackward,
  FaStepForward,
  FaStepBackward,
  FaFastForward,
  FaFastBackward,
  FaRandom,
  FaRepeat,
  FaRedoAlt,
  FaUndoAlt,
  FaSyncAlt,
  FaSpinner,
  FaCircleNotch,
  FaHourglassHalf,
  FaHourglassStart,
  FaHourglassEnd,
  FaHourglass,
  FaStopwatch,
  FaClock as FaTime,
  FaCalendarDay,
  FaCalendarWeek,
  FaCalendarMonth,
  FaCalendarYear,
  FaCalendarPlus,
  FaCalendarMinus,
  FaCalendarEdit,
  FaCalendarX,
  FaCalendarAlt as FaCalendarAltIcon,
  FaCalendarCheck as FaCalendarCheckIcon,
  FaCalendarTimes as FaCalendarTimesIcon,
  FaCalendarDay as FaCalendarDayIcon,
  FaCalendarWeek as FaCalendarWeekIcon,
  FaCalendarMonth as FaCalendarMonthIcon,
  FaCalendarYear as FaCalendarYearIcon,
  FaCalendarPlus as FaCalendarPlusIcon,
  FaCalendarMinus as FaCalendarMinusIcon,
  FaCalendarEdit as FaCalendarEditIcon,
  FaCalendarX as FaCalendarXIcon,
  FaEye,
  FaEdit,
  FaSync,
  FaBell,
  FaShieldAlt,
  FaDatabase,
  FaServer,
  FaNetworkWired,
  FaLock,
  FaUnlock,
  FaKey,
  FaUserLock,
  FaUserCheck,
  FaUserTimes,
  FaBan,
  FaUserAlt,
  FaUsers,
  FaUserGraduate,
  FaUserMd,
  FaUserNurse,
  FaSearch,
  FaFilter
} from 'react-icons/fa';

// Website color palette
const websiteColorPalette = {
  primary: '#0077B6',
  secondary: '#20B2AA',
  background: '#FFFFFF',
  text: '#333333',
  accent: '#28A745'
};

const BulkCreate = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [newAccount, setNewAccount] = useState({
    email: '',
    name: '',
    role: 'student',
    studentId: '',
    universityId: '',
    clinicId: '',
    affiliationType: 'university',
    dentistId: '',
    accountType: 'microsoft'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [showTemplate, setShowTemplate] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [validationResults, setValidationResults] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [clinics, setClinics] = useState([]);
  const navigate = useNavigate();
  const { user, token } = useAuth();

  const handleAddAccount = () => {
    if (!newAccount.email || !newAccount.name || !newAccount.role) {
      setError('Please fill in all required fields');
      return;
    }

    if (newAccount.role === 'student' && !newAccount.studentId) {
      setError('Student ID is required for student accounts');
      return;
    }

    if (['student', 'supervisor', 'admin', 'it'].includes(newAccount.role) && !newAccount.universityId) {
      setError('University ID is required for this role');
      return;
    }


    if (newAccount.role === 'assistant') {
      if (!newAccount.affiliationType) {
        setError('Affiliation type is required for assistant accounts');
        return;
      }
      if (newAccount.affiliationType === 'university' && !newAccount.universityId) {
        setError('University ID is required for university-affiliated assistants');
        return;
      }
      if (newAccount.affiliationType === 'dentist' && !newAccount.dentistId) {
        setError('Dentist ID is required for dentist-affiliated assistants');
        return;
      }
    }

    // Check if email already exists in the list
    if (accounts.some(acc => acc.email === newAccount.email)) {
      setError('This email is already in the list');
      return;
    }

    // Clean account data - only include role-specific fields
    const accountToAdd = { 
      email: newAccount.email,
      name: newAccount.name,
      role: newAccount.role,
      universityId: newAccount.universityId,
      accountType: newAccount.accountType,
      id: Date.now()
    };
    
     // Add role-specific fields
     if (newAccount.role === 'student') {
       accountToAdd.studentId = newAccount.studentId;
     } else if (newAccount.role === 'assistant') {
      accountToAdd.affiliationType = newAccount.affiliationType;
      // Only include dentistId if affiliationType is 'dentist'
      if (newAccount.affiliationType === 'dentist') {
        accountToAdd.dentistId = newAccount.dentistId;
      }
    }
    
    setAccounts([...accounts, accountToAdd]);
    setNewAccount({
      email: '',
      name: '',
      role: 'student',
      studentId: '',
      universityId: user?.university || '',
      clinicId: '',
      affiliationType: 'university',
      dentistId: '',
      accountType: 'microsoft'
    });
    setError('');
  };

  const handleRemoveAccount = (index) => {
    setAccounts(accounts.filter((_, i) => i !== index));
  };

  const handleClearAll = () => {
    setAccounts([]);
    setError('');
    setSuccess('');
  };

  const handleValidateAccounts = () => {
    const results = accounts.map((account, index) => {
      const errors = [];
      
      if (!account.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(account.email)) {
        errors.push('Invalid email format');
      }
      
      if (!account.name || account.name.trim().length < 2) {
        errors.push('Name must be at least 2 characters');
      }
      
      
      if (account.role === 'student' && !account.studentId) {
        errors.push('Student ID is required');
      }
      
      if (['student', 'supervisor', 'admin', 'it'].includes(account.role) && !account.universityId) {
        errors.push('University ID is required');
      }
      
      
      return {
        index,
        account,
        errors,
        isValid: errors.length === 0
      };
    });
    
    setValidationResults(results);
    setShowValidation(true);
  };

  const handleDownloadTemplate = (role = 'all') => {
    let template, filename, instructions;
    
    if (role === 'student') {
      template = [
        ['Email', 'Name', 'Role', 'Student ID', 'University ID'],
        ['john.doe@university.edu', 'John Doe', 'student', 'STU001', user?.university || 'UNI001'],
        ['jane.smith@university.edu', 'Jane Smith', 'student', 'STU002', user?.university || 'UNI001']
      ];
      filename = 'student_account_template.xlsx';
      instructions = [
        ['Student Account Template Instructions'],
        [''],
        ['Required Fields:'],
        ['- Email: Must be a valid university email address'],
        ['- Name: Full name of the student'],
        ['- Role: Must be "student"'],
        ['- Student ID: Unique student identifier'],
        ['- University ID: Your university identifier'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
    } else if (role === 'admin') {
      template = [
        ['Email', 'Name', 'Role', 'University ID'],
        ['admin1@university.edu', 'Admin User 1', 'admin', user?.university || 'UNI001'],
        ['admin2@university.edu', 'Admin User 2', 'admin', user?.university || 'UNI001']
      ];
      filename = 'admin_account_template.xlsx';
      instructions = [
        ['Admin Account Template Instructions'],
        [''],
        ['Required Fields:'],
        ['- Email: Must be a valid university email address'],
        ['- Name: Full name of the admin'],
        ['- Role: Must be "admin"'],
        ['- University ID: Your university identifier'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
    } else if (role === 'supervisor') {
      template = [
        ['Email', 'Name', 'Role', 'University ID'],
        ['supervisor1@university.edu', 'Supervisor User 1', 'supervisor', user?.university || 'UNI001'],
        ['supervisor2@university.edu', 'Supervisor User 2', 'supervisor', user?.university || 'UNI001']
      ];
      filename = 'supervisor_account_template.xlsx';
      instructions = [
        ['Supervisor Account Template Instructions'],
        [''],
        ['Required Fields:'],
        ['- Email: Must be a valid university email address'],
        ['- Name: Full name of the supervisor'],
        ['- Role: Must be "supervisor"'],
        ['- University ID: Your university identifier'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
    } else if (role === 'assistant') {
      template = [
        ['Email', 'Name', 'Role', 'University ID', 'Affiliation Type', 'Dentist ID'],
        ['assistant1@university.edu', 'Assistant User 1', 'assistant', user?.university || 'UNI001', 'university', ''],
        ['assistant2@university.edu', 'Assistant User 2', 'assistant', user?.university || 'UNI001', 'dentist', 'DENT001']
      ];
      filename = 'assistant_account_template.xlsx';
      instructions = [
        ['Assistant Account Template Instructions'],
        [''],
        ['Required Fields:'],
        ['- Email: Must be a valid university email address'],
        ['- Name: Full name of the assistant'],
        ['- Role: Must be "assistant"'],
        ['- University ID: Your university identifier'],
        ['- Affiliation Type: university or dentist'],
        ['- Dentist ID: Required only if affiliation type is dentist'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
     } else if (role === 'it') {
      template = [
        ['Email', 'Name', 'Role', 'University ID'],
        ['it1@university.edu', 'IT User 1', 'it', user?.university || 'UNI001'],
        ['it2@university.edu', 'IT User 2', 'it', user?.university || 'UNI001']
      ];
      filename = 'it_account_template.xlsx';
      instructions = [
        ['IT Account Template Instructions'],
        [''],
        ['Required Fields:'],
        ['- Email: Must be a valid university email address'],
        ['- Name: Full name of the IT user'],
        ['- Role: Must be "it"'],
        ['- University ID: Your university identifier'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
    } else {
       // All roles template
       template = [
         ['Email', 'Name', 'Role', 'Student ID', 'University ID', 'Affiliation Type', 'Dentist ID'],
         ['student@university.edu', 'Student User', 'student', 'STU001', user?.university || 'UNI001', 'university', ''],
         ['admin@university.edu', 'Admin User', 'admin', '', user?.university || 'UNI001', 'university', ''],
         ['supervisor@university.edu', 'Supervisor User', 'supervisor', '', user?.university || 'UNI001', 'university', ''],
         ['assistant@university.edu', 'Assistant User', 'assistant', '', user?.university || 'UNI001', 'university', ''],
         ['it@university.edu', 'IT User', 'it', '', user?.university || 'UNI001', 'university', '']
       ];
      filename = 'all_roles_account_template.xlsx';
      instructions = [
        ['Account Creation Template Instructions'],
        [''],
         ['Required Fields:'],
         ['- Email: Must be a valid email address'],
         ['- Name: Full name of the user'],
         ['- Role: student, admin, supervisor, assistant, it'],
         [''],
         ['Conditional Fields:'],
         ['- Student ID: Required only for student role'],
         ['- University ID: Required for student, supervisor, admin, it roles'],
         ['- Affiliation Type: Required only for assistant role (university or dentist)'],
         ['- Dentist ID: Required only for dentist-affiliated assistants'],
        [''],
        ['Notes:'],
        ['- All accounts will be created as Microsoft accounts'],
        ['- No password needed for Microsoft accounts'],
        ['- Remove this instructions sheet before uploading']
      ];
    }
    
    // Create Excel file
    const ws = XLSX.utils.aoa_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Account Template');
    
    // Add instructions sheet
    const wsInstructions = XLSX.utils.aoa_to_sheet(instructions);
    XLSX.utils.book_append_sheet(wb, wsInstructions, 'Instructions');
    
    XLSX.writeFile(wb, filename);
  };

  const handleExportAccounts = () => {
    if (accounts.length === 0) {
      setError('No accounts to export');
      return;
    }
    
    const csvContent = [
      ['Email', 'Name', 'Role', 'Student ID', 'University ID', 'Clinic ID', 'Affiliation Type', 'Dentist ID', 'Account Type'],
      ...accounts.map(account => [
        account.email,
        account.name,
        account.role,
        account.studentId || '',
        account.universityId || '',
        account.clinicId || '',
        account.affiliationType || '',
        account.dentistId || '',
        account.accountType || 'microsoft'
      ])
    ].map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bulk_accounts_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
  };

  // Fetch universities and clinics on component mount
  useEffect(() => {
    const fetchData = async () => {
      if (!user || !token) return;

      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        // Fetch universities
        try {
          const universitiesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/universities`, config);
          setUniversities(universitiesResponse.data || []);
        } catch (err) {
          console.error('Error fetching universities:', err);
          setUniversities([]);
        }
        
        // Fetch clinics
        try {
          const clinicsResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/clinics`, config);
          setClinics(clinicsResponse.data || []);
        } catch (err) {
          console.error('Error fetching clinics:', err);
          setClinics([]);
          // Don't show error to user as clinics are optional for most roles
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, [user, token]);

  // Auto-populate universityId when user data is available
  useEffect(() => {
    if (user?.university && !newAccount.universityId) {
      setNewAccount(prev => ({ ...prev, universityId: user.university }));
    }
  }, [user, newAccount.universityId]);

  const handleBulkCreate = async () => {
    if (accounts.length === 0) {
      setError('Please add at least one account');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Clean accounts data - remove invalid fields based on role
      const cleanedAccounts = accounts.map(account => {
        const cleanedAccount = { ...account };
        
        
        // Remove affiliationType from non-assistant roles
        if (cleanedAccount.role !== 'assistant') {
          delete cleanedAccount.affiliationType;
        }
        
        // Remove dentistId from non-assistant roles
        if (cleanedAccount.role !== 'assistant') {
          delete cleanedAccount.dentistId;
        }
        
        // Remove studentId from non-student roles
        if (cleanedAccount.role !== 'student') {
          delete cleanedAccount.studentId;
        }
        
        // For assistants, remove dentistId if affiliationType is not 'dentist'
        if (cleanedAccount.role === 'assistant' && cleanedAccount.affiliationType !== 'dentist') {
          delete cleanedAccount.dentistId;
        }
        
        return cleanedAccount;
      });

      console.log('Cleaned accounts being sent:', cleanedAccounts);

      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/it/accounts/bulk`,
        { accounts: cleanedAccounts },
        config
      );

      const { successful, failed } = response.data.results;
      
      if (successful.length > 0) {
        setSuccess(`Successfully created ${successful.length} accounts`);
        // Remove only successful accounts from the list
        setAccounts(accounts.filter(acc => !successful.some(s => s.email === acc.email)));
      }

      if (failed.length > 0) {
        const failedDetails = failed.map(f => `${f.email}: ${f.error}`).join('\n');
        setError(`${failed.length} accounts failed to create:\n${failedDetails}`);
        // Keep failed accounts in the list so user can fix them
      }

    } catch (error) {
      console.error('Error creating accounts:', error);
      setError('Error creating accounts. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['.xlsx', '.xls', '.csv'];
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    
    if (!validTypes.includes(fileExtension)) {
      setError('Please upload a valid Excel (.xlsx, .xls) or CSV file');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        let newAccounts = [];
        
        if (fileExtension === '.csv') {
          // Handle CSV files
        const text = e.target.result;
        const lines = text.split('\n').filter(line => line.trim());

        lines.forEach((line, index) => {
            if (index === 0) return; // Skip header
            
            const columns = line.split(',').map(item => item.trim());
            
            // Handle different column orders - look for role in common positions
            let email = '', name = '', role = '', studentId = '', universityId = '', clinicId = '', affiliationType = 'university', dentistId = '', accountType = 'microsoft';
            
            if (columns.length >= 3) {
              // Try to identify columns by content patterns
              for (let i = 0; i < columns.length; i++) {
                const col = columns[i].toLowerCase();
                if (col.includes('@') && !email) {
                  email = columns[i];
                 } else if (['student', 'admin', 'supervisor', 'assistant', 'it'].includes(col) && !role) {
                  role = col;
                 } else if (!name && col.length > 2 && !col.includes('@') && !['student', 'admin', 'supervisor', 'assistant', 'it', 'university'].includes(col)) {
                  name = columns[i];
                }
              }
              
              // If we still don't have role, try positional approach
              if (!role && columns.length >= 3) {
                role = columns[2].toLowerCase(); // Assume role is in 3rd position
              }
              
              // Fill other fields based on position
              if (columns.length > 3) studentId = columns[3] || '';
              if (columns.length > 4) universityId = columns[4] || '';
              if (columns.length > 5) clinicId = columns[5] || '';
              if (columns.length > 6) affiliationType = columns[6] || 'university';
              if (columns.length > 7) dentistId = columns[7] || '';
              if (columns.length > 8) accountType = columns[8] || 'microsoft';
            }
            
            if (email && name && role) {
              const accountData = {
              email,
              name,
              role: role.toLowerCase(),
                universityId,
                accountType
              };
              
               // Add role-specific fields
               if (role.toLowerCase() === 'student') {
                 accountData.studentId = studentId;
               } else if (role.toLowerCase() === 'assistant') {
                 accountData.affiliationType = affiliationType;
                 // Only include dentistId if affiliationType is 'dentist'
                 if (affiliationType === 'dentist') {
                   accountData.dentistId = dentistId;
                 }
               }
               
               newAccounts.push(accountData);
             }
           });
        } else {
          // Handle Excel files
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get the first worksheet
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          // Skip header row and process data
          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i];
            if (row.length < 3) continue; // Skip incomplete rows
            
            const columns = row.map(item => String(item || '').trim());
            
            // Handle different column orders - look for role in common positions
            let email = '', name = '', role = '', studentId = '', universityId = '', clinicId = '', affiliationType = 'university', dentistId = '', accountType = 'microsoft';
            
            if (columns.length >= 3) {
              // Try to identify columns by content patterns
              for (let i = 0; i < columns.length; i++) {
                const col = columns[i].toLowerCase();
                if (col.includes('@') && !email) {
                  email = columns[i];
                 } else if (['student', 'admin', 'supervisor', 'assistant', 'it'].includes(col) && !role) {
                  role = col;
                 } else if (!name && col.length > 2 && !col.includes('@') && !['student', 'admin', 'supervisor', 'assistant', 'it', 'university'].includes(col)) {
                  name = columns[i];
                }
              }
              
              // If we still don't have role, try positional approach
              if (!role && columns.length >= 3) {
                role = columns[2].toLowerCase(); // Assume role is in 3rd position
              }
              
              // Fill other fields based on position
              if (columns.length > 3) studentId = columns[3] || '';
              if (columns.length > 4) universityId = columns[4] || '';
              if (columns.length > 5) clinicId = columns[5] || '';
              if (columns.length > 6) affiliationType = columns[6] || 'university';
              if (columns.length > 7) dentistId = columns[7] || '';
              if (columns.length > 8) accountType = columns[8] || 'microsoft';
            }
            
            if (email && name && role) {
              const accountData = {
                email,
                name,
                role: role.toLowerCase(),
                universityId,
                accountType
              };
              
               // Add role-specific fields
               if (role.toLowerCase() === 'student') {
                 accountData.studentId = studentId;
               } else if (role.toLowerCase() === 'assistant') {
                 accountData.affiliationType = affiliationType;
                 // Only include dentistId if affiliationType is 'dentist'
                 if (affiliationType === 'dentist') {
                   accountData.dentistId = dentistId;
                 }
               }
               
               newAccounts.push(accountData);
             }
           }
        }

        // Validate imported accounts
        const validationErrors = [];
        newAccounts.forEach((account, index) => {
          const errors = [];
          
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(account.email)) {
            errors.push('Invalid email format');
          }
          
          if (!account.name || account.name.length < 2) {
            errors.push('Name must be at least 2 characters');
          }
          
          if (!account.role) {
            errors.push('Role is required');
           } else if (!['student', 'admin', 'supervisor', 'assistant', 'it'].includes(account.role.toLowerCase())) {
             errors.push(`Invalid role "${account.role}". Must be one of: student, admin, supervisor, assistant, it`);
          }
          
          
          if (account.role === 'student' && !account.studentId) {
            errors.push('Student ID is required for student role');
          }
          
          if (['student', 'supervisor', 'admin', 'it'].includes(account.role) && !account.universityId) {
            errors.push('University ID is required for this role');
          }
          
          
          if (account.role === 'assistant') {
            if (!account.affiliationType) {
              errors.push('Affiliation type is required for assistant role');
            }
            if (account.affiliationType === 'dentist' && !account.dentistId) {
              errors.push('Dentist ID is required for dentist-affiliated assistants');
            }
          }
          
          if (errors.length > 0) {
            validationErrors.push({
              row: index + 2, // +2 because we skip header and arrays are 0-indexed
              email: account.email,
              errors: errors
            });
          }
        });

        if (validationErrors.length > 0) {
          setError(`File validation failed. Please fix the following errors and upload again:\n${validationErrors.map(err => `Row ${err.row} (${err.email}): ${err.errors.join(', ')}`).join('\n')}`);
          return;
        }

        if (newAccounts.length > 0) {
          setAccounts([...accounts, ...newAccounts]);
          setSuccess(`Successfully imported ${newAccounts.length} accounts from file`);
          setError(''); // Clear any previous errors
        } else {
          setError('No valid accounts found in the file. Please check the format and try again.');
        }
      } catch (error) {
        console.error('Error parsing file:', error);
        setError('Error parsing file. Please ensure the file format is correct and try again.');
      }
    };
    
    if (fileExtension === '.csv') {
    reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };


  return (
    <div className="flex h-screen bg-gray-50">
      <ITSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-gradient-to-br from-blue-50 to-white">
          <div className="max-w-7xl mx-auto">
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
              <div className="mb-6 sm:mb-8">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
                  <div>
                <h1 className={`text-2xl sm:text-3xl md:text-4xl font-bold text-[${websiteColorPalette.primary}] mb-1`}>Bulk Create Accounts</h1>
                <p className={`text-[${websiteColorPalette.text}]`}>Create multiple accounts at once</p>
                  </div>
                  
                  <div className="flex flex-wrap gap-2 mt-4 sm:mt-0">
                    <button
                      onClick={handleValidateAccounts}
                      disabled={accounts.length === 0}
                      className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors flex items-center disabled:bg-gray-400"
                    >
                      <FaCheckCircle className="h-4 w-4 mr-2" />
                      Validate
                    </button>
                    <button
                      onClick={handleClearAll}
                      disabled={accounts.length === 0}
                      className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center disabled:bg-gray-400"
                    >
                      <FaTrash className="h-4 w-4 mr-2" />
                      Clear All
                    </button>
                    <button
                      onClick={handleDownloadTemplate}
                      className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center"
                    >
                      <FaFileCsv className="h-4 w-4 mr-2" />
                      Template
                    </button>
                    <button
                      onClick={handleExportAccounts}
                      disabled={accounts.length === 0}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center disabled:bg-gray-400"
                    >
                      <FaDownload className="h-4 w-4 mr-2" />
                      Export
                    </button>
                  </div>
                </div>
                
                {/* Stats Summary */}
                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
                  <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                    <div className="flex items-center">
                      <FaUsers className="h-8 w-8 text-blue-500 mr-3" />
                      <div>
                        <p className="text-sm font-medium text-gray-600">Total Accounts</p>
                        <p className="text-2xl font-bold text-gray-900">{accounts.length}</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                    <div className="flex items-center">
                      <FaUserGraduate className="h-8 w-8 text-green-500 mr-3" />
                      <div>
                        <p className="text-sm font-medium text-gray-600">Students</p>
                        <p className="text-2xl font-bold text-gray-900">{accounts.filter(a => a.role === 'student').length}</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                    <div className="flex items-center">
                      <FaUserMd className="h-8 w-8 text-purple-500 mr-3" />
                      <div>
                        <p className="text-sm font-medium text-gray-600">Staff</p>
                        <p className="text-2xl font-bold text-gray-900">{accounts.filter(a => ['admin', 'supervisor', 'assistant'].includes(a.role)).length}</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                    <div className="flex items-center">
                      <FaShieldAlt className="h-8 w-8 text-orange-500 mr-3" />
                      <div>
                        <p className="text-sm font-medium text-gray-600">IT Accounts</p>
                        <p className="text-2xl font-bold text-gray-900">{accounts.filter(a => a.role === 'it').length}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Error/Success Messages */}
              {error && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-lg shadow-sm"
                >
                  <div className="flex items-center">
                    <FaTimes className="w-5 h-5 text-red-500 mr-3" />
                    <p className="text-red-700 font-medium">{error}</p>
                  </div>
                </motion.div>
              )}

              {success && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 rounded-lg shadow-sm"
                >
                  <div className="flex items-center">
                    <FaCheck className="w-5 h-5 text-green-500 mr-3" />
                    <p className="text-green-700 font-medium">{success}</p>
                  </div>
                </motion.div>
              )}

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Add Account Form */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                    <FaUserPlus className="h-5 w-5 mr-2 text-blue-600" />
                    Add Single Account
                  </h2>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                      <input
                        type="email"
                        value={newAccount.email}
                        onChange={(e) => setNewAccount({ ...newAccount, email: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="user@university.edu"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                      <input
                        type="text"
                        value={newAccount.name}
                        onChange={(e) => setNewAccount({ ...newAccount, name: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="John Doe"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Role *</label>
                      <select
                        value={newAccount.role}
                        onChange={(e) => {
                          const newRole = e.target.value;
                          setNewAccount(prev => ({
                            ...prev,
                            role: newRole,
                            // Auto-populate universityId for roles that require it
                            universityId: ['student', 'supervisor', 'admin', 'it'].includes(newRole) 
                              ? (user?.university || prev.universityId) 
                              : prev.universityId
                          }));
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                         <option value="student">Student</option>
                         <option value="admin">Admin</option>
                         <option value="supervisor">Supervisor</option>
                         <option value="assistant">Assistant</option>
                         <option value="it">IT</option>
                      </select>
                    </div>

                    {newAccount.role === 'student' && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Student ID *</label>
                        <input
                          type="text"
                          value={newAccount.studentId}
                          onChange={(e) => setNewAccount({ ...newAccount, studentId: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder="12345"
                        />
                      </div>
                    )}

                    {['student', 'supervisor', 'admin', 'it'].includes(newAccount.role) && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">University ID *</label>
                      <input
                          type="text"
                          value={newAccount.universityId}
                          onChange={(e) => setNewAccount({ ...newAccount, universityId: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder="Auto-populated with your university"
                          readOnly
                      />
                        <p className="text-xs text-gray-500 mt-1">Automatically set to your university</p>
                    </div>
                    )}


                    {newAccount.role === 'assistant' && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Affiliation Type *</label>
                          <select
                            value={newAccount.affiliationType}
                            onChange={(e) => setNewAccount({ ...newAccount, affiliationType: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          >
                            <option value="university">University</option>
                            <option value="dentist">Dentist</option>
                          </select>
                        </div>
                        {newAccount.affiliationType === 'university' && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">University ID *</label>
                            <input
                              type="text"
                              value={newAccount.universityId}
                              onChange={(e) => setNewAccount({ ...newAccount, universityId: e.target.value })}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              placeholder="Auto-populated with your university"
                              readOnly
                            />
                            <p className="text-xs text-gray-500 mt-1">Automatically set to your university</p>
                          </div>
                        )}
                        {newAccount.affiliationType === 'dentist' && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Dentist ID *</label>
                            <input
                              type="text"
                              value={newAccount.dentistId}
                              onChange={(e) => setNewAccount({ ...newAccount, dentistId: e.target.value })}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              placeholder="DENT001"
                            />
                          </div>
                        )}
                      </>
                    )}


                    <button
                      onClick={handleAddAccount}
                      className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
                    >
                      <FaPlus className="h-4 w-4 mr-2" />
                      Add to List
                    </button>
                  </div>
                </div>

                {/* File Upload */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                    <FaUpload className="h-5 w-5 mr-2 text-green-600" />
                    Import from File
                  </h2>
                  
                  <div className="space-y-4">
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                      <FaFileExcel className="h-8 w-8 text-gray-400 mx-auto mb-2" />
                      <p className="text-sm text-gray-600 mb-2">Upload Excel (.xlsx, .xls) or CSV file with account data</p>
                      <input
                        type="file"
                        accept=".csv,.xlsx,.xls"
                        onChange={handleFileUpload}
                        className="hidden"
                        id="file-upload"
                      />
                      <label
                        htmlFor="file-upload"
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors cursor-pointer inline-block"
                      >
                        Choose File
                      </label>
                    </div>

                    <div className="space-y-2">
                    <button
                        onClick={() => handleDownloadTemplate('all')}
                      className="w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors flex items-center justify-center"
                    >
                      <FaDownload className="h-4 w-4 mr-2" />
                        All Roles Template
                      </button>
                      <div className="grid grid-cols-2 gap-2">
                        <button
                          onClick={() => handleDownloadTemplate('student')}
                          className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm"
                        >
                          Student
                        </button>
                        <button
                          onClick={() => handleDownloadTemplate('admin')}
                          className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                        >
                          Admin
                        </button>
                        <button
                          onClick={() => handleDownloadTemplate('supervisor')}
                          className="px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm"
                        >
                          Supervisor
                        </button>
                        <button
                          onClick={() => handleDownloadTemplate('assistant')}
                          className="px-3 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors text-sm"
                        >
                          Assistant
                        </button>
                         <button
                          onClick={() => handleDownloadTemplate('it')}
                          className="px-3 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm"
                        >
                          IT
                    </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Accounts List */}
              {accounts.length > 0 && (
                <div className="mt-6 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                  <div className="p-6 border-b border-gray-200">
                    <div className="flex justify-between items-center">
                      <h2 className="text-lg font-semibold text-gray-900">
                        Accounts to Create ({accounts.length})
                      </h2>
                      <button
                        onClick={handleBulkCreate}
                        disabled={loading}
                        className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                      >
                        {loading ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                            Creating...
                          </>
                        ) : (
                          <>
                            <FaCheck className="h-4 w-4 mr-2" />
                            Create All Accounts
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="text-left py-3 px-6 font-semibold text-gray-700">Name</th>
                          <th className="text-left py-3 px-6 font-semibold text-gray-700">Email</th>
                          <th className="text-left py-3 px-6 font-semibold text-gray-700">Role</th>
                          <th className="text-left py-3 px-6 font-semibold text-gray-700">Student ID</th>
                          <th className="text-left py-3 px-6 font-semibold text-gray-700">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {accounts.map((account, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="py-4 px-6 text-sm font-medium text-gray-900">{account.name}</td>
                            <td className="py-4 px-6 text-sm text-gray-900">{account.email}</td>
                            <td className="py-4 px-6">
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                account.role === 'student' ? 'bg-green-100 text-green-800' :
                                account.role === 'admin' ? 'bg-blue-100 text-blue-800' :
                                account.role === 'supervisor' ? 'bg-purple-100 text-purple-800' :
                                'bg-orange-100 text-orange-800'
                              }`}>
                                {account.role}
                              </span>
                            </td>
                            <td className="py-4 px-6 text-sm text-gray-900">{account.studentId || '-'}</td>
                            <td className="py-4 px-6">
                              <button
                                onClick={() => handleRemoveAccount(index)}
                                className="text-red-600 hover:text-red-800 p-1"
                              >
                                <FaTrash className="h-4 w-4" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </motion.div>
          </div>
        </main>
      </div>

      {/* Validation Results Modal */}
      {showValidation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-900">Validation Results</h2>
              <button
                onClick={() => setShowValidation(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>
            <div className="space-y-4">
              {validationResults.map((result, index) => (
                <div key={index} className={`p-4 rounded-lg border ${
                  result.isValid ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
                }`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-gray-900">{result.account.name} ({result.account.email})</p>
                      <p className="text-sm text-gray-600">Role: {result.account.role}</p>
                    </div>
                    <div className="flex items-center">
                      {result.isValid ? (
                        <FaCheckCircle className="h-5 w-5 text-green-500" />
                      ) : (
                        <FaExclamationCircle className="h-5 w-5 text-red-500" />
                      )}
                    </div>
                  </div>
                  {result.errors.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm font-medium text-red-700">Errors:</p>
                      <ul className="list-disc list-inside text-sm text-red-600">
                        {result.errors.map((error, errorIndex) => (
                          <li key={errorIndex}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="flex justify-end space-x-4 pt-4">
              <button
                onClick={() => setShowValidation(false)}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preview Modal */}
      {showPreview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-900">Account Preview</h2>
              <button
                onClick={() => setShowPreview(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>
            <div className="space-y-4">
              {accounts.map((account, index) => (
                <div key={index} className="p-4 bg-gray-50 rounded-lg">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm font-medium text-gray-700">Name</p>
                      <p className="text-gray-900">{account.name}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-700">Email</p>
                      <p className="text-gray-900">{account.email}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-700">Role</p>
                      <p className="text-gray-900">{account.role}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-700">Student ID</p>
                      <p className="text-gray-900">{account.studentId || '-'}</p>
                    </div>
                    {account.universityId && (
                      <div>
                        <p className="text-sm font-medium text-gray-700">University ID</p>
                        <p className="text-gray-900">{account.universityId}</p>
                      </div>
                    )}
                    {account.clinicId && (
                      <div>
                        <p className="text-sm font-medium text-gray-700">Clinic ID</p>
                        <p className="text-gray-900">{account.clinicId}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-end space-x-4 pt-4">
              <button
                onClick={() => setShowPreview(false)}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkCreate;
